import createVueApp from '@phoenix/createVueApp';
import PromotionBanner from '@maison/components/widgets/PromotionBanner.vue';

const app = createVueApp();
app.component('PromotionBanner', PromotionBanner);
app.mount('#promotion-banner');
